import {
  BACKGROUNDS_RIGHT_PANEL_ID,
  TEMPLATES_RIGHT_PANEL_ID,
} from '@/lib/panels/right-panel-events'

/**
 * `RightPanel`'s panel ids, as stored in `activePanel` and sent through
 * `requestRightPanelOpen`/`requestRightPanelClose`. Several carry a trailing space; code outside
 * the panel tree already depends on these exact values, so keep them verbatim.
 */
export const RIGHT_PANEL_IDS = {
  spreads: 'spreads ',
  photos: 'photos',
  portraits: 'portraits ',
  clikart: 'clikart',
  templates: TEMPLATES_RIGHT_PANEL_ID,
  backgrounds: BACKGROUNDS_RIGHT_PANEL_ID,
  adorders: 'adorders',
} as const
